import React from 'react';
import { useTranslation } from 'react-i18next';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import { StyledFormControlLabel } from './PositionChoose.styled';

function PositionChoose(props) {
  const { t } = useTranslation();
  const { positionChoose, setPositionChoose, isDisabled, isSpeech } = props;
  const handlePositionChooseChange = (e) => {
    setPositionChoose(e.target.value);
  };
  return (
    <FormControl component='fieldset'>
      <RadioGroup
        aria-label='positionChoose'
        name='positionChoose'
        value={positionChoose}
        onChange={handlePositionChooseChange}
      >
        {
          isSpeech ?
          <StyledFormControlLabel
            value='speech'
            control={<Radio />}
            label={t('SpeechChoose')}
            disabled={isDisabled}
          /> :
          <div></div>
        }
        <StyledFormControlLabel
          value='rectangle'
          control={<Radio />}
          label={t('RectangleChoose')}
          disabled={isDisabled}
        />

        <StyledFormControlLabel
          value='line'
          control={<Radio />}
          label={t('LineChoose')}
          disabled={isDisabled}
        />

        <StyledFormControlLabel
          value='circle'
          control={<Radio />}
          label={t('CircleChoose')}
          disabled={isDisabled}
        />
      </RadioGroup>
    </FormControl>
  );
}

export default PositionChoose;
